module.exports = __webpack_public_path__ + "media/svg/enveloppe-48cb271a.svg";